// @ts-nocheck
// Vuex module の段階的 TypeScript 化（まずはファイル移管。詳細な型は後続対応）
const state = {
  displayState: 'normal',
  displayedCoachMark: false,
}

const mutations = {
  setDisplayState(state, displayState) {
    state.displayState = displayState
  },
  setDisplayedCoachMark(state, displayedCoachMark) {
    state.displayedCoachMark = displayedCoachMark
  },
  resetState() {
    state.displayState = 'normal'
  },
}

const getters = {
  displayState(state) {
    return state.displayState
  },
  displayedCoachMark(state) {
    return state.displayedCoachMark
  },
}

const actions = {}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
